import { NgModule } from '@angular/core';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';
import {DashboardAnalyticsComponent} from './dashboard-analytics/dashboard-analytics.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NzTableModule} from 'ng-zorro-antd/table';
import {CommonModule} from '@angular/common';
import {MomentModule} from 'ngx-moment';
import { ChartsModule, ThemeService } from 'ng2-charts';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { NgZorroAntdModule } from '../utilities/ng-zorro-antd.module';

@NgModule({
  imports: [
    CommonModule,
    DashboardRoutingModule,
    NgZorroAntdModule,
    FormsModule,
    ReactiveFormsModule,
    NzTableModule,
    MomentModule,
    ChartsModule,
    NgxQRCodeModule,
  ],
  declarations: [DashboardComponent, DashboardAnalyticsComponent],
  exports: [DashboardComponent, DashboardAnalyticsComponent],
  providers: [ThemeService]
})
export class DashboardModule { }
